import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import DocumentSaving from 'components/ModalWindows/DocumentSaving';
import * as Models from 'components/ModalWindows/DocumentSaving/models';
import { hideModal } from 'containers/ModalManager/actions';
import { modalWindowOptions } from 'containers/ModalManager/selectors';

const mapStateToProps = (state, props: Models.IDocumentSavingProps) => createStructuredSelector({
  options: modalWindowOptions(props.modalWindowId),
});

const mapDispatchToProps = {
  hideModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentSaving);
